import PhotoSwipeLightbox from "photoswipe/lightbox";
import PhotoSwipe from "photoswipe";

class Gallery {
  constructor($el) {
    this.$el = $el;
    this.init();
  }

  init = () => {
    this.photoswipe = new PhotoSwipeLightbox({
      gallery: this.$el[0],
      children: '[data-gallery="item"]',
      pswpModule: PhotoSwipe,
      mainClass: "pswp--pit",
      bgOpacity: 1,
      showHideAnimationType: "none",
      initialZoomLevel: "fit",
      secondaryZoomLevel: 1,
      maxZoomLevel: 2,
      preload: [1, 1],
    });
    this.photoswipe.init();
  };
}

export default Gallery;
